import { render, staticRenderFns } from "./FiltroAdmin.vue?vue&type=template&id=533812d0&scoped=true&"
import script from "./FiltroAdmin.vue?vue&type=script&lang=js&"
export * from "./FiltroAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533812d0",
  null
  
)

export default component.exports